import { Link } from '@/i18n/navigation';
import Image from 'next/image';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import styles from './main-page-cat.module.scss';
import { slugify } from '@/components/shared/slug';

export const renderCollection = (
  collections: any,
  handleTabChange: any,
  tab: any,
  isBottom: boolean,
  limit?: number
) => {
  return collections
    ?.filter((col: any) => col?.node?.isInCatalog)
    ?.filter((col: any) => col?.node?.isBottom === isBottom)
    .slice(0, limit)
    .map((collection: any) => {
      const item = collection.node;
      const link = `/collection/${decodeBase64Id(item.id)}-${slugify(item.name)}`;

      return (
        <Link
          href={link}
          key={item.id}
          onClick={() => handleTabChange(item.id)}
          className={`${styles.mainPageCategoryItem} ${
            tab === item.id ? styles.categoryActive : null
          }`}
        >
          <div className={styles.mainPageCategoryItemText}>
            <Image
              src={item?.backgroundImage?.url || '/'}
              alt={item?.name}
              className={styles.brandLogo}
              width={20}
              height={20}
            />
            <p>{item?.name}</p>
          </div>
        </Link>
      );
    });
};
